import { Check } from "lucide-react";

const PROBLEM_IMG =
  "https://static.prod-images.emergentagent.com/jobs/10165ba5-237c-4471-8603-ea6dbde73886/images/ce6f1ba89acde51b6f6a88351649810d6d48ad6701dd9f3c8fb84a021555787e.png";

const pains = [
  "Llegas a casa sin energía y no quieres ni jugar con tus hijos.",
  "Has probado mil dietas y siempre vuelves al punto de partida.",
  "Tu trabajo, las comidas fuera y el estrés se han comido tu salud.",
  "Te miras al espejo y no reconoces al hombre que eras hace 10 años.",
  "Sabes que necesitas ayuda real, no otra app más.",
];

export const Problema = () => {
  return (
    <section
      id="problema"
      data-testid="section-problema"
      className="relative bg-[#0A0A0A] py-24 sm:py-32 border-t border-zinc-900"
    >
      <div className="w-full max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 grid lg:grid-cols-2 gap-12 lg:gap-20 items-start">
        {/* Left: heading + pains */}
        <div className="lg:sticky lg:top-28">
          <p className="text-xs sm:text-sm text-[#FF5A1F] uppercase tracking-[0.25em] font-bold mb-6">
            01 — El problema
          </p>
          <h2
            data-testid="problema-heading"
            className="font-display font-black uppercase text-white text-4xl sm:text-5xl lg:text-6xl leading-[0.95] tracking-tighter"
          >
            No te falta fuerza de voluntad.
            <span className="block text-zinc-500">
              Te falta un método que encaje con tu vida.
            </span>
          </h2>
          <p className="mt-6 text-lg text-zinc-400 leading-relaxed max-w-xl">
            La mayoría de hombres de +35 no fracasan por vagos. Fracasan
            siguiendo planes diseñados para otra persona, en otra etapa de la
            vida. Tu agenda, tu cuerpo y tu cabeza piden algo distinto.
          </p>
        </div>

        {/* Right: image + list */}
        <div>
          <div className="relative grain overflow-hidden border border-zinc-800">
            <img
              src={PROBLEM_IMG}
              alt="Hombre agotado tras una larga jornada de trabajo"
              className="w-full h-[420px] object-cover grayscale-[40%] contrast-110"
              data-testid="problema-image"
            />
            <div className="absolute bottom-0 inset-x-0 bg-gradient-to-t from-black via-black/40 to-transparent h-1/2 pointer-events-none" />
            <div className="absolute bottom-6 left-6 right-6">
              <p className="font-display uppercase text-3xl font-black text-white tracking-tight">
                ¿Te suena familiar?
              </p>
            </div>
          </div>

          <ul className="mt-8 space-y-4">
            {pains.map((p, i) => (
              <li
                key={i}
                data-testid={`pain-item-${i}`}
                className="flex items-start gap-4 group"
              >
                <span className="mt-1 shrink-0 w-7 h-7 flex items-center justify-center bg-[#FF5A1F]/10 border border-[#FF5A1F]/40 text-[#FF5A1F]">
                  <Check size={14} strokeWidth={3} />
                </span>
                <p className="text-zinc-300 text-base sm:text-lg leading-relaxed">
                  {p}
                </p>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};
